<template>
    <multiselect :disabled="this.disabled" v-model="valueSelected" :options="communities" track-by="uuid" label="name"
        :multiple="false" :allowEmpty="false" placeholder="Comunidad" selectedLabel="" selectLabel="" deselectLabel=""
        @select="notifyChange"></multiselect>
</template>
<script>

import Multiselect from "vue-multiselect";
import { getCommunities } from "../../api/location-api";

export default {
    name: "NewLocationCommunitySelector",
    components: {
        Multiselect,
    },
    async mounted() {
        getCommunities().then(communities => {
            this.communities = communities;

            if(this.communitySelected !== null) {
                let findedCommunity = this.communities.find(community => community.uuid === this.communitySelected.uuid);
                this.valueSelected = findedCommunity;
            }else if(this.initialCommunity !== null) {
                let findedCommunity = this.communities.find(community => community.name === this.initialCommunity);
                this.valueSelected = findedCommunity;
                this.onSelected(findedCommunity);
            }
        });
        
    },
    props: {
        communitySelected: Object,
        disabled: Boolean,
        onSelected: Function,
        initialCommunity: String,
        onFieldClear: Function,
    },
    data: function () {
        return {
            communities: [],
            valueSelected: null,
        };
    },
    methods: {
        notifyChange: function(value) {
            this.onSelected(value);
            this.onFieldClear([ 'province', 'town', 'postalCode' ]);
        },
    }
}

</script>
